/**
 * @description urlToList
 * @param url url
 */
export function urlToList(url: string) {
    const urllist = url.split('/').filter(i => i);
    //@ts-ignore
    return urllist.map((item, index) => `/${urllist.slice(0, index + 1).join('/')}`);
}
